import GlobalAxios from "../../../axios/axios-config";
import {
  IInsurance,
  IInsuranceCategory,
  IInsuranceFavorite,
  IInsuranceFavoriteBase,
} from "./model";

const TASY_INSURANCE_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/IndividualTasyInsuranceFavorite";

const INSURANCE_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/tasy/InsuranceRegister";

const INSURANCE_ROUTE_TASY_2 =
  process.env.REACT_APP_CALENDAR + "/api/v1/tasy_2/InsuranceRegister";

const NEW_SCHEDULE_INSURANCE_ROUTE_TASY_2 =
  process.env.REACT_APP_CALENDAR +
  "/api/v1/tasy_2/InsuranceRegister/NewSchedule";

const INSURANCE_CATEGORY_ROUTE_TASY_2 =
  process.env.REACT_APP_CALENDAR + "/api/v1/tasy_2/InsuranceRegisterCategory";

export class ScheduleInsuranceService {
  public static list = (params?: {
    IndividualId: string;
    TicketAutomationReceivedRuleId?: string;
  }) => {
    return GlobalAxios.get<IInsuranceFavorite[]>(
      TASY_INSURANCE_ROUTE + "/list",
      { params },
    );
  };

  public static delete = (id: string) => {
    return GlobalAxios.delete<IInsuranceFavorite[]>(
      TASY_INSURANCE_ROUTE + `/${id}`,
    );
  };

  public static getById = (id: string) => {
    return GlobalAxios.get<IInsuranceFavorite>(TASY_INSURANCE_ROUTE + `/${id}`);
  };

  public static edit = ({
    data,
    id,
  }: {
    id: string;
    data: IInsuranceFavoriteBase;
  }) => {
    return GlobalAxios.put<IInsuranceFavorite>(
      TASY_INSURANCE_ROUTE + `/${id}`,
      { ...data, id },
    );
  };

  public static editMain = ({
    data,
    insuranceIntegrationId,
  }: {
    insuranceIntegrationId: string;
    data: { insuranceIntegrationId: string };
  }) => {
    return GlobalAxios.put<IInsuranceFavorite>(
      TASY_INSURANCE_ROUTE + `/Favorite/${insuranceIntegrationId}`,
      { ...data, insuranceIntegrationId },
    );
  };

  public static create = (params: IInsuranceFavoriteBase) => {
    return GlobalAxios.post<{ id: string }>(TASY_INSURANCE_ROUTE, params);
  };

  public static all = () => {
    return GlobalAxios.get<IInsurance[]>(INSURANCE_ROUTE + "/all");
  };

  public static allTasy2 = (params?: {
    SearchBy?: string;
    Identifier?: number;
  }) => {
    return GlobalAxios.get<IInsurance[]>(INSURANCE_ROUTE_TASY_2 + "/all", {
      params,
    });
  };

  public static newScheduleAllTasy2 = (params?: {
    SearchBy?: string;
    Identifier?: number;
    EstablishmentCode?: string;
  }) => {
    return GlobalAxios.get<IInsurance[]>(
      NEW_SCHEDULE_INSURANCE_ROUTE_TASY_2 + "/all",
      { params },
    );
  };

  public static categoriesTasy2 = (params: { InsuranceIdentifier: number }) => {
    return GlobalAxios.get<IInsuranceCategory[]>(
      INSURANCE_CATEGORY_ROUTE_TASY_2,
      { params },
    );
  };
}
